import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loading-more"
};
const _hoisted_2 = {
  class: "scroller-container"
};
const _hoisted_3 = {
  class: "spokesman"
};
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { ElInput, ElMessage } from 'element-plus';
import { stageChat } from '@/tools/stageChat';
import dayjs from 'dayjs';
import ChatCell from '@/components/Stage/ChatCell.vue';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/index.css'; // pre-declaration

export default {
  __name: 'ChatContainer',
  props: {
    stageId: {
      type: String,
      required: true
    },
    currentRole: {
      type: [Object, null],
      required: true
    },
    roleArray: {
      type: Array,
      required: true
    },
    translucent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['message-click', 'speak'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const scrollerRef = ref(null);
    const shouldAutoScroll = ref(true);
    const now = ref(dayjs().tz('Asia/Shanghai'));
    const content = ref('');
    const prevMessage = ref(null);
    const isComposing = ref(false);
    let lastCompositionEndTime = 0; // computed

    const roleInfoMap = computed(() => {
      if (!props.roleArray) return {};
      return props.roleArray.reduce((map, item) => {
        // console.log('item.id', item)
        if (item && item['id']) {
          map[item.id] = item;
        }

        return map;
      }, {});
    }); // functions

    const getRoleInfo = roleId => {
      if (!Object.keys(roleInfoMap.value).includes(roleId)) {
        return {
          'id': 'unknown',
          'nickname': '雾海游魂'
        };
      }

      return roleInfoMap.value[roleId];
    };

    const handleScroll = event => {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = event.target;
      shouldAutoScroll.value = scrollHeight - scrollTop - clientHeight < 100;

      if (scrollTop < 50) {
        loadMore();
      }
    };

    const scrollToBottom = async (force = false) => {
      if (!scrollerRef.value) return;
      await nextTick();

      if (force || shouldAutoScroll.value) {
        scrollerRef.value.scrollToBottom({
          smooth: true
        });
      }
    };

    const handleCompositionStart = () => {
      isComposing.value = true;
    };

    const handleCompositionEnd = () => {
      isComposing.value = false;
      lastCompositionEndTime = Date.now();
    };

    const handleKeyDown = event => {
      if (event.key === 'Enter') {
        const justFinishedComposition = Date.now() - lastCompositionEndTime < 50;

        if (event.isComposing || isComposing.value || justFinishedComposition) {
          return;
        }

        if (!event.shiftKey) {
          event.preventDefault();
          submitContent();
        }
      } else if (event.key === 'ArrowUp') {
        if (content.value.length === 0) {
          if (selfMessages.value.length > 0) {
            prevMessage.value = selfMessages.value[selfMessages.value.length - 1];
            content.value = prevMessage.value.content;
          }
        } else if (prevMessage.value != null) {
          const index = selfMessages.value.indexOf(prevMessage.value);

          if (index > 0) {
            prevMessage.value = selfMessages.value[index - 1];
            content.value = prevMessage.value.content;
          }
        }
      } else if (event.key === 'ArrowDown') {
        if (prevMessage.value != null) {
          const index = selfMessages.value.indexOf(prevMessage.value);

          if (index < selfMessages.value.length - 1) {
            prevMessage.value = selfMessages.value[index + 1];
            content.value = prevMessage.value.content;
          } else if (index === selfMessages.value.length - 1) {
            prevMessage.value = null;
            content.value = '';
          }
        }
      } else {
        if (prevMessage.value) {
          prevMessage.value = null;
        }
      }
    };

    const submitContent = () => {
      if (!content.value || content.value.length === 0) {
        ElMessage.error({
          message: '需要输入内容',
          duration: 1500
        });
        return;
      }

      emits('speak', content.value);
      content.value = '';
    };

    const updateTimeTag = () => {
      now.value = dayjs().tz('Asia/Shanghai');
    };

    const forceUpdate = () => {
      if (scrollerRef.value) {
        // console.log('forceUpdate', messages.value.length)
        if (messages.value.length === 0) {
          const timestamp = Math.floor(new Date().getTime());
          addMessage({
            'id': `${props.stageId}_admin_${timestamp}`,
            'timestamp': timestamp,
            'stage_id': props.stageId,
            'role_id': 'admin',
            'type': 'event',
            'content': '一切故事的开始'
          });
        }

        scrollerRef.value.forceUpdate();
        scrollToBottom();
      }
    }; // post-declaration


    const {
      isInitializing,
      messages,
      loading,
      selfMessages,
      // totalCount,
      addMessage,
      addSelfMessage,
      loadMore,
      clearMessages,
      fetchMessageWithIndexedDB,
      updateConfig
    } = stageChat({
      'stageId': props.stageId,
      'roleId': props.currentRole.id
    });

    __expose({
      isInitializing,
      addMessage,
      addSelfMessage,
      clearMessages,
      loadMore,
      scrollToBottom,
      updateTimeTag,
      forceUpdate,
      fetchMessageWithIndexedDB,
      updateConfig
    }); // lifecycle


    onMounted(() => {
      fetchMessageWithIndexedDB();
    });
    watch(() => messages, () => {
      forceUpdate();
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["chat-container", __props.translucent ? 'translucent' : ''])
      }, [_unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", null, "加载中...", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(DynamicScroller), {
        ref_key: "scrollerRef",
        ref: scrollerRef,
        class: "message-list",
        items: _unref(messages),
        "min-item-size": 60,
        "key-field": "timestamp",
        onScroll: handleScroll
      }, {
        default: _withCtx(({
          item,
          index,
          active
        }) => [_createVNode(_unref(DynamicScrollerItem), {
          item: item,
          active: active,
          "data-index": index
        }, {
          default: _withCtx(() => [_createVNode(ChatCell, {
            "is-self": __props.currentRole !== null && __props.currentRole.id.toString() === item.role_id.toString(),
            message: item,
            "role-info": getRoleInfo(item.role_id),
            now: now.value
          }, null, 8, ["is-self", "message", "role-info", "now"])]),
          _: 2
        }, 1032, ["item", "active", "data-index"])]),
        _: 1
      }, 8, ["items"])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElInput), {
        modelValue: content.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => content.value = $event),
        maxlength: "512",
        placeholder: "输入内容进行发言",
        round: "",
        type: "textarea",
        clearable: "",
        autosize: {
          minRows: 1,
          maxRows: 4
        },
        onKeydown: handleKeyDown,
        onCompositionstart: handleCompositionStart,
        onCompositionend: handleCompositionEnd
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        onClick: submitContent
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 提交 ", -1)]))]),
        _: 1
      })])], 2);
    };
  }

};